@if(service.viewDroplistItems.length){
<div class='configuration-planning-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem' (selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true' sortBy='customSort' style='display:inline-block'>
	</droplist>
	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.Trimesters) {
	<configuration-planning-trimesters-view-part></configuration-planning-trimesters-view-part>
	}
	@case (service.viewId.Staff) {
	<configuration-planning-staff-view-part></configuration-planning-staff-view-part>
	}
	}
	}
</div>
}